/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, breakpoints } from '@coursera/cds-core';

import LoadingSpinner from 'bundles/grading/components/common/LoadingSpinner';

import _t from 'i18n!nls/grading';

const styles = {
  dialogContent: css`
    /* We have BS styles on the page, which add margin-bottom: 0.5rem
  to all labels, including CDS's TextField label */
    label {
      margin-bottom: 0;
    }
  `,
  primaryButton: css`
    ${breakpoints.down('xs')} {
      width: 100%;
      max-width: none;
    }
  `,
  secondaryButton: css`
    margin: 0 var(--cds-spacing-300) 0;
    ${breakpoints.down('xs')} {
      width: 100%;
      max-width: none;
      margin: var(--cds-spacing-300) 0 0;
    }
  `,
};

type Props = {
  onClose: () => void;
  heading: string;
  primaryButtonLabel: string;
  primaryButtonDisabled: boolean;
  primaryButtonOnClick: () => void;
  applyingOnClickAction: boolean;
  secondaryButtonLabel?: string;
  secondaryButtonDisabled?: boolean;
  secondaryButtonOnClick?: () => void;
  children?: React.ReactNode;
  dataTestidPrefix?: string;
};

const ControlsDialog = ({
  onClose,
  heading,
  primaryButtonLabel,
  primaryButtonDisabled,
  primaryButtonOnClick,
  applyingOnClickAction,
  secondaryButtonLabel = _t('Cancel'),
  secondaryButtonDisabled = primaryButtonDisabled,
  secondaryButtonOnClick = onClose,
  dataTestidPrefix,
  children,
}: Props) => {
  const { HeadingGroup, Content, Actions } = Dialog;
  return (
    <Dialog aria-describedby="dialog-content" open={true} variant="transactional" onClose={onClose} sticky="actions">
      <HeadingGroup>{heading}</HeadingGroup>
      <Content id="dialog-content" css={styles.dialogContent}>
        {children}
      </Content>
      <Actions>
        <Button
          css={styles.primaryButton}
          variant="primary"
          onClick={primaryButtonOnClick}
          disabled={primaryButtonDisabled}
          icon={applyingOnClickAction ? <LoadingSpinner /> : undefined}
          iconPosition="before"
          data-testid={`${dataTestidPrefix}-primaryBtn`}
        >
          {primaryButtonLabel}
        </Button>
        <Button
          css={styles.secondaryButton}
          variant="secondary"
          onClick={secondaryButtonOnClick}
          disabled={secondaryButtonDisabled}
          data-testid={`${dataTestidPrefix}-secondaryBtn`}
        >
          {secondaryButtonLabel}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default ControlsDialog;
